<div class="page-overlay" *ngIf="isBusy" style="height: 100%;">
  <div class="center">
    <mat-spinner color="accent"></mat-spinner>
  </div>
</div>
<div class="main-fab">
  <mat-icon *ngIf="isAnyInEditMode" 
            style="cursor: default;vertical-align: top" 
            color="accent"
            matTooltip="Sie haben ungespeicherte Änderungen. Das Angebot kann erst als PDF Datei runtergeladen werden, nachdem alle Änderungen gespeichert wurden.">
    info_outline
  </mat-icon>
  <button mat-fab color="accent"
          matTooltip="Angbot als PDF Datei runterladen"
          matTooltipShowDelay=1250
          [disabled]="isAnyInEditMode" 
          (click)="createOfferDocument()">
    <mat-icon>file_download</mat-icon>
  </button>
</div>
<div class="main-page-content">
  <h1>{{csProject?.projectName}}</h1>
  <mat-accordion>
    
    <app-section name="project" class="cs-buildup-section">
      <a header>Projektdaten</a>
      <app-project-section [csProject]="csProject"></app-project-section>
    </app-section>

    <app-section name="chargingStations" class="cs-buildup-section">
      <a header>Ladestationen & Zähleranschlusssäule</a>
      <app-charging-stations-section [projectId]="projectId"></app-charging-stations-section>
    </app-section>

    <app-section name="projectPreperation" class="cs-buildup-section">
      <a header>Projektabwicklung</a>
      <app-project-preperation-section [projectId]="projectId"></app-project-preperation-section>
    </app-section>

    <app-section name="csInstallation" class="cs-buildup-section">
      <a header>Standortplanung & Installation</a>
      <app-cs-installation-section [projectId]="projectId"></app-cs-installation-section>
    </app-section>

    <app-section name="subsidy" class="cs-buildup-section">
      <a header>Förderung</a>
      <app-subsidy-section [projectId]="projectId"></app-subsidy-section>
    </app-section>

    <app-section name="operation" class="cs-buildup-section">
      <a header>Jährliche Betriebskosten</a>
      <app-operation-section [projectId]="projectId"></app-operation-section>
    </app-section>

  </mat-accordion>
  
  <h1 [ngClass]="initializingTotalCosts ? 'blurry-text' : ''" style="text-align: right; margin-right: 48px; margin-top: 24px;">Anschaffungskosten (netto): {{totalCosts | currency}}</h1> 

</div>
